<div class="min-h-screen w-full">
  <router-outlet></router-outlet>
  <p-toast position="bottom-center"></p-toast>
</div>
